import { apiFetch } from './client.ts';

export interface ApiUser {
  id: string;
  username: string;
  email: string;
  country: string;
  elo: number;
  streak: number;
  createdAt: string;
  avatarId: string | null;
  avatarFilename: string | null;
  playerCardDecoration: string;
  puzzleCount: number;
  liveMatchCount: number;
  liveMatchWins: number;
  tournamentCount: number;
  tournamentWins: number;
  communitySolveCount: number;
  communityBestCount: number;
  endlessCount: number;
  achievementCount: number;
  speedrunBestMs: number | null;
}

export interface ApiPublicUser {
  id: string;
  username: string;
  country: string;
  elo: number;
  streak: number;
  puzzleCount: number;
  liveMatchCount: number;
  liveMatchWins: number;
  tournamentCount: number;
  tournamentWins: number;
  communitySolveCount: number;
  communityBestCount: number;
  endlessCount: number;
  achievementCount: number;
  speedrunBestMs: number | null;
  createdAt: string;
  avatarFilename: string | null;
  playerCardDecoration: string;
}

export function getMe(token: string): Promise<ApiUser> {
  return apiFetch('/api/users/me', { token });
}

export function updateMe(
  data: { username?: string; country?: string; avatarId?: string | null; playerCardDecoration?: string },
  token: string,
): Promise<ApiUser> {
  return apiFetch('/api/users/me', { method: 'PATCH', body: data, token });
}

export function getUser(id: string): Promise<ApiPublicUser> {
  return apiFetch(`/api/users/${encodeURIComponent(id)}`);
}

export function checkUsername(username: string): Promise<{ available: boolean }> {
  return apiFetch(`/api/users/check-username?username=${encodeURIComponent(username)}`);
}
